import React from "react";
import PageHeading from "../../components/common/PageHeading";
import SpringContainer from "../../components/containers/SpringContainer";
import Accounts from "./components/Accounts";
import DangerZone from "./components/DangerZone";
import ProfileDetails from "./components/ProfileDetails";

export default function Profile() {
  return (
    <SpringContainer className="h-full flex flex-col gap-6 max-w-4xl">
      <PageHeading heading="Profile" />
      <ProfileDetails />
      <Accounts />
      <DangerZone />
    </SpringContainer>
  );
}
